import { Fragment } from 'react';
import { Divider, Flex, Text } from '@mantine/core';
import { IconMail, IconMapPins, IconPhone, type IconProps } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MeetingDetailsCard } from './MeetingDetailsCard';

type Props = {
  name: string;
  summary?: string;
  address?: string | null;
  email?: string | null;
  phone?: string | null;
};

export function ParticipantInfoCard({ name, summary, address, email, phone }: Props) {
  const rows: { icon: React.ComponentType<IconProps>; value: string }[] = [
    { icon: IconMapPins, value: address || 'Not provided' },
    { icon: IconMail, value: email || 'Not provided' },
    { icon: IconPhone, value: phone || 'Not provided' },
  ];

  return (
    <MeetingDetailsCard title={name} description={summary}>
      <div>
        {rows.map((row, index) => (
          <Fragment key={index}>
            {index > 0 && <Divider color="gray.1" />}
            <Flex align="center" gap="xxs" py="xs">
              <row.icon size={20} color="var(--mantine-color-gray-10)" style={{ flexShrink: 0 }} />
              <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
                {row.value}
              </Text>
            </Flex>
          </Fragment>
        ))}
      </div>
    </MeetingDetailsCard>
  );
}
